export const STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'approved', label: 'Approved' },
  { value: 'in_review', label: 'In review' },
  { value: 'archived', label: 'Archived' },
];
